import { render } from "./AnnularEclipse2023.vue?vue&type=template&id=5a772c3d&ts=true"
import script from "./AnnularEclipse2023.vue?vue&type=script&lang=ts"
export * from "./AnnularEclipse2023.vue?vue&type=script&lang=ts"

import "./AnnularEclipse2023.vue?vue&type=style&index=0&id=5a772c3d&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__